import * as AllIcon from '@ant-design/icons';
import { App } from '@yimoka/antd';
import { useLocation, useMiniNavigate, useRouteParams } from '@yimoka/mini-router';
import { ConfigProvider, type IConfig, type IGetIcon } from '@yimoka/react';
import type { INotifier } from '@yimoka/store';
import { get } from 'lodash-es';
import React, { useMemo, type PropsWithChildren } from 'react';

import { apiExecutor } from '@/http';

import { components } from './components';

const titleMap: Record<string, string> = {
  success: '成功',
  error: '错误',
  info: '提示',
  warning: '警告',
  warn: '警告',
  confirm: '确认',
  loading: '加载',
};

const getIcon: IGetIcon = async (icon: string) => {
  if (!icon) return null;
  if (icon in AllIcon) {
    return AllIcon[icon as keyof typeof AllIcon] as React.ComponentType;
  }
  return null;
};

export function TenantWebConfig({ children }: PropsWithChildren) {
  const { notification } = App.useApp();

  const notifier = useMemo(() => ((type, msg, options) => {
    if (type === 'close') {
      notification.destroy(msg ?? options?.key);
      return;
    }
    const fn = get(notification, type);
    if (typeof fn === 'function') {
      const { message, title, description, ...restOptions } = options ?? {};
      fn({
        ...restOptions,
        title: title ?? message ?? titleMap[type] ?? type,
        description: msg || description,
      });
    }
  }) as INotifier, [notification]);

  const config: IConfig = useMemo(() => ({
    apiExecutor,
    notifier,
    getIcon,
    useLocation,
    useNavigate: useMiniNavigate,
    useRouteParams,
    components,
  }), [notifier]);

  return <ConfigProvider value={config}>{children}</ConfigProvider>;
}
